module.exports = __webpack_public_path__ + "media/application/images/colors/books_green-6eca4e3ef30f8eb22d7ea983754a0465.png";